var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    rx: 15.333,
    fill: "#96F9FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.436 22.593a.895.895 0 0 0 1.128 0l10.273-8.385a3.18 3.18 0 0 0-1.678-.48H13.84a3.18 3.18 0 0 0-1.678.48l10.273 8.385z",
    fill: "#17CADC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.721 24.013c-.499.408-1.11.611-1.722.611a2.719 2.719 0 0 1-1.721-.61L10.94 15.575a3.176 3.176 0 0 0-.305 1.358v10.99a3.21 3.21 0 0 0 3.205 3.205h18.316a3.209 3.209 0 0 0 3.206-3.205v-10.99a3.19 3.19 0 0 0-.306-1.358l-10.335 8.437z",
    fill: "#17CADC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeMessage);
export default __webpack_public_path__ + "static/media/homeMessage.685e97e31339e372baad0f81ebed10d7.svg";
export { ForwardRef as ReactComponent };